module.exports = __webpack_public_path__ + "static/media/notes.b5e22793.svg";